export default __webpack_public_path__ + "static/media/down-square.073cc401.svg";